// eslint-disable-next-line
import React from 'react';
import ReactDOM from 'react-dom';
import './analytics';

import App from './ui/containers/App';

window.APC_ENABLE_JO = false;

ReactDOM.render(<App />, document.getElementById('tradeups-app'));
